import React from 'react';

interface BetaBadgeProps {
    text?: string;
    className?: string;
    style?: React.CSSProperties;
    position?: 'absolute' | 'relative' | 'static';
    top?: string;
    right?: string;
    transform?: string;
    letterSpacing?: string;
    fontSize?: string;
}

const BetaBadge: React.FC<BetaBadgeProps> = ({
    text = "BETA",
    className = "",
    style = {},
    position = 'relative',
    top,
    right,
    transform,
    letterSpacing = "0.5px",
    fontSize = "10px"
}) => {
    const defaultClassName = "badge bg-primary text-white d-flex align-items-center justify-content-center fw-medium px-2 rounded-pill";
    const combinedClassName = position === 'absolute'
        ? `${defaultClassName} position-absolute ${className}`
        : `${defaultClassName} ${className}`;

    const defaultStyle: React.CSSProperties = {
        letterSpacing,
        fontSize,
    };

    if (position === 'absolute') {
        defaultStyle.top = top || '50%';
        defaultStyle.right = right || '12px';
        defaultStyle.transform = transform || 'translateY(-50%)';
    }

    const combinedStyle = { ...defaultStyle, ...style };

    return (
        <span
            className={combinedClassName}
            style={combinedStyle}
        >
            {text}
        </span>
    );
};

export default BetaBadge;
